export class EnvironmentService<Environment> {
	public constructor(private readonly variables: Environment) {
		this.variables = import.meta.env as Environment;
	}

	public get<T>(name: keyof Environment): T {
		return <T>(<unknown>this.variables[name]);
	}
}
